import React, { FC, memo, PropsWithChildren } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AuditEvent } from "types/track/AuditEventType";
export type FAQAccordionProps = PropsWithChildren<{
  title: string;
}>;
const FAQAccordion: FC<FAQAccordionProps> = memo(({
    title,
    children,
}: FAQAccordionProps) => {
  return (
    <Accordion
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        "&:before": {
          display: "none",
        },
      }}
    >
      <AccordionSummary
        sx={{
          "& .Mui-buttonBase-root:focus": {
            outline: "none",
          },
        }}
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography variant="h5" fontWeight="bold" component="h2">
          {title}
        </Typography>
      </AccordionSummary>

      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
});
FAQAccordion.displayName = "FAQs";

export default FAQAccordion;
